import React from 'react';
import { Text } from '../../../../../components/Typography/Typography';
import { ConversationPreview, ClientConversation } from '../../../../../store/chat/types';
import ConversationItem from './ConversationItem';
import styles from './ConversationGroup.module.scss';

interface ConversationGroupProps {
  title: string;
  conversations: ConversationPreview[];
  currentConversation: ClientConversation | null;
  onSelectConversation: (conversation: ConversationPreview) => void;
}

const ConversationGroup: React.FC<ConversationGroupProps> = ({
  title,
  conversations,
  currentConversation,
  onSelectConversation,
}) => {
  if (conversations.length === 0) return null;

  return (
    <div className={styles.group}>
      <div className={styles.groupTitle}>
        <Text size="base" weight="semibold" color="neutral-700">
          {title}
        </Text>
      </div>
      <div className={styles.groupItems}>
        {conversations.map((conversation) => (
          <ConversationItem
            key={conversation.id}
            conversation={conversation}
            isActive={currentConversation?.id === conversation.id}
            onClick={onSelectConversation}
          />
        ))}
      </div>
    </div>
  );
};

export default ConversationGroup;
